import { useEffect, useMemo, useState } from "react";
import { newAxiosClient } from "@shadowcue/ui";
import type { IDashboard } from "../types/idashboard";

interface UseDashboardResult {
  dashboard: IDashboard | null;
  loading: boolean;
  error: boolean;
}

/**
 * Loads the dashboard's counts and a page of the viewer's own conversations
 * from /api/dashboard. The counts span the organization for admins; the
 * conversation list is always the viewer's own.
 */
const useDashboard = (authToken: string, page: number): UseDashboardResult => {
  const axios = useMemo(() => newAxiosClient(), []);

  const [dashboard, setDashboard] = useState<IDashboard | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    const fetchDashboard = async () => {
      try {
        const res = await axios.get<IDashboard>("/api/dashboard", {
          headers: { AUTHORIZATION: `Bearer ${authToken}` },
          params: { page },
        });
        setDashboard(res.data);
      } catch {
        setError(true);
      } finally {
        setLoading(false);
      }
    };

    fetchDashboard();
  }, [authToken, page]);

  return { dashboard, loading, error };
};

export default useDashboard;
